import { updateViewRequest } from 'modules/messagingInsights/actions';
import { useViewContext } from 'modules/messagingInsights/context';
import { selectSavedView } from 'modules/messagingInsights/selectors';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { SecondaryButton, PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useViewsModals } from '../hooks/useViewsModals';
import { useGetCurrSettings } from '../hooks/useGetCurrSettings';

const content = {
  header: 'Unsaved changes',
  warning: 'has has been edited. Do you want to save your changes?',
  cancel: 'Cancel',
  save: 'Save and exit',
  discard: 'Leave without saving',
};

export const UnsavedViewModal: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const modals = useViewsModals();
  const view = useSelector(selectSavedView) || {};
  const { toggleRefetchView } = useViewContext();
  const currSettings = useGetCurrSettings();

  const handleClose = () => modals.unsaved.toggle(false);

  // redirect to desired path upon saving changes
  const saveCallback = () => {
    history.push(modals.unsaved.redirectPath, { isBlocked: false });
  };

  const handleSave = () => {
    if (view) {
      dispatch(updateViewRequest({ ...view, settings: currSettings }, saveCallback));
      handleClose();
    }
  };
  const handleDiscard = () => {
    history.push(modals.unsaved.redirectPath, { isBlocked: false });
    toggleRefetchView();
    handleClose();
  };

  return (
    <Modal
      id="unsaved-view-modal"
      isModalOpen={true}
      onClose={handleClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{content.header}</ModalHeader>
      <ModalBody>
        <b>{view.name}</b> {content.warning}
      </ModalBody>
      <ModalFooter cancelLabel={content.cancel}>
        <SecondaryButton onClick={handleDiscard} size={BUTTON_SIZES.LARGE}>
          {content.discard}
        </SecondaryButton>
        <PrimaryButton data-test="save-changes" onClick={handleSave} size={BUTTON_SIZES.LARGE}>
          {content.save}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
